import React, { Component } from "react";

import Sidebar from "../components/Sidebar"
import DrugOrderDetails from './components/DrugOrderDetails'

class OnboardingDrugOrder extends Component {
  render() {
    return (
      <main className={"dashboard content-page " + this.props.type}>
        <Sidebar />
        <DrugOrderDetails {...this.props} isOnboarding={true} />
      </main>
    )
  }
}

export default OnboardingDrugOrder;
